<div class="row wrapper border-bottom white-bg page-heading info-projeto">
  <div class="col-lg-10 title-projeto">
    <h2>QR Obras</h2>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content box-content-layout">
          <div class="info-page">
            <h3>{{ actionLabel }} Documento</h3>
          </div>


          <form [formGroup]="form" (ngSubmit)="salvar()">
            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Título</label>
                <textarea id="title" class="form-control" rows="3" formControlName="title" required maxlength="150"></textarea>
                <app-field-message [field]="fieldMessageRequired('title')" [erros]="fieldErros('title')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Descrição</label>
                <textarea id="description" class="form-control" rows="3" formControlName="description" required maxlength="150"></textarea>
                <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-5">
                <label class="col-sm-12 pb-1">Tipo</label>
                <ng-select id="type_id" class="ng-select-alternative" [items]="list?.typeList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="type_id">
                  <ng-template ng-option-tmp let-item="item">
                    <div [title]="item.title">
                      {{ item.label }}
                    </div>
                  </ng-template>
                </ng-select>
                <app-field-message [field]="fieldMessageRequired('type_id')" [erros]="fieldErros('type_id')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-5">
                <label class="col-sm-12 pb-1">Arquivo</label>
                <input type="file" id="file" class="form-control" formControlName="file" (change)="onFileSelected($event)" />
                <app-field-message [field]="fieldMessageRequired('file')" [erros]="fieldErros('file')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-t-mdx" *ngIf="entity?.id">
              <div class="col-sm-5">
                <label class="col-sm-12 pb-1">Arquivo Atual</label>
                <div class="list-arquivos">
                  <div>
                    <h5>Arquivo:</h5>
                    <p class="download" (click)="download()">{{ entity?.name }}</p>
                  </div>
                  <div>
                    <h5>Autor:</h5>
                    <p>{{ entity?.owner_cpf }}</p>
                  </div>
                  <div>
                    <h5>Criado em:</h5>
                    <p>{{ entity?.created_at }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row d-flex justify-content-end">
              <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
                <button class="btn btn-primary" type="submit">Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>